import Cookies from 'js-cookie';
import { useState, useCallback } from 'react';

export const useCookie = (
    cookieName: string
): [
    string | null,
    (newValue: string, options?: Cookies.CookieAttributes) => void,
    () => void
] => {
    const [value, setValue] = useState<string | null>(
        () => Cookies.get(cookieName) ?? null
    );

    const updateCookie = useCallback(
        (newValue: string, options?: Cookies.CookieAttributes) => {
            Cookies.set(cookieName, newValue, options);
            setValue(newValue);
        },
        [cookieName]
    );

    const deleteCookie = useCallback(() => {
        Cookies.remove(cookieName);
        setValue(null);
    }, [cookieName]);

    return [value, updateCookie, deleteCookie];
};

export const getCookie = (cookieName: string) => {
    return Cookies.get(cookieName);
};

export const setCookie = (cookieName: string, newValue: string) => {
    Cookies.set(cookieName, newValue);
};

export const removeCookie = (cookieName: string) => {
    Cookies.remove(cookieName);
};
